import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '../config';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
import { getPublicSession } from '../publicSession/selectors';
const CANONICAL_XHR_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
const LOCAL_XHR_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(response), 1000);
    });
}
function getApiResponse(options) {
    const cancelTokenSource = axios.CancelToken.source();
    const promise = axios.request(options.enableCancellation ? _object_spread_props(_object_spread({}, options), {
        cancelToken: cancelTokenSource.token
    }) : options).then((response)=>{
        return response.data;
    }).catch(()=>{
        return false;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = ()=>cancelTokenSource.cancel();
    }
    return promise;
}
export function isApiError(response) {
    return response.error || response.errorCode;
}
export function* request(options, fakeResponse) {
    var _session_device, _session;
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = yield select(ConfigSelectors.key('sharedApiBasePath'));
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_ENDPOINT;
        }
    }
    // CSRF
    const csrf = yield select(ConfigSelectors.key('csrfToken'));
    if (options.method && options.method.toLowerCase() === 'post') {
        if (options.data === undefined) {
            options.data = {};
        }
        options.data['csrf_token'] = csrf;
    } else {
        if (options.params === undefined) {
            options.params = {};
        }
        options.params['csrf_token'] = csrf;
    }
    const withCreds = yield select(ConfigSelectors.key('withCredentials'));
    if (withCreds) {
        options.withCredentials = true;
    }
    // Accept header image support
    const session = yield select(getPublicSession);
    if ((_session_device = (_session = session) === null || _session === void 0 ? void 0 : _session.device) === null || _session_device === void 0 ? void 0 : _session_device.supportsWebp) {
        options.headers = _object_spread_props(_object_spread({}, options.headers), {
            Accept: 'application/json, text/plain, image/webp, */*'
        });
    }
    let result;
    // Using node env so we strip for prod bundle sdf sdf sdf
    if (process.env.NODE_ENV !== 'production') {
        if (fakeResponse !== undefined) {
            const doFake = yield select(ConfigSelectors.key('fakeApiRequests'));
            if (doFake) {
                ddt.log('saga', `Faked XHR for: ${options.url}`, options, fakeResponse(options));
                result = yield call(getFakeResponse, fakeResponse(options));
                return result;
            }
        }
    }
    result = yield call(getApiResponse, options);
    return result;
}
